import React from 'react';
import PropTypes from 'prop-types';
import style from './index.scss';

export const AlertLevels = ({ data }) => {
  if (data)
    return (
      <div className={style.hitSummary}>
        <div key={1} className={data?.High ? style.hitSummary_high : ''}>
          {data?.High ? 'High: ' + data?.High?.toLocaleString('en-US') : '--'}
        </div>
        <div key={2} className={data?.Good ? style.hitSummary_good : ''}>
          {data?.Good ? 'Good: ' + data?.Good?.toLocaleString('en-US') : '--'}
        </div>
        <div key={3} className={data?.Low ? style.hitSummary_low : ''}>
          {data?.Low ? 'Low: ' + data?.Low?.toLocaleString('en-US') : '--'}
        </div>
      </div>
    );
  else return null;
};

AlertLevels.propTypes = {
  data: PropTypes.object
};

export default AlertLevels;
